import React from "react";
import styles from "../utils/gridStyles.js";
import dateFormat from 'dateformat';
import setHeaderRender from "../../components/app/setHeaderRender";

const setColumns = ({ modalDetail, allowWrite, changeDelay}) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
        },
        {
            id: "code",
            field: "code",
            label: "Code",
            width: '100px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Code', changeDelay, tableManager, column}) )
        },
        {
            id: "2",
            field: "username",
            label: "Username",
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'UserName', changeDelay, tableManager, column}) )
        },
        {
            id: "4",
            field: "endpoint",
            label: "Endpoint",
            width: '450px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Endpoint', changeDelay, tableManager, column}) )
        },
        {
            id: "5",
            field: "method",
            label: "Method",
            width: '90px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Method', changeDelay, tableManager, column}) )
        },
        {
            id: "6",
            field: "ip",
            label: "Ip",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'IP', changeDelay, tableManager, column}) )
        },
        {
            id: "8",
            field: "createdAt",
            label: "CreatedAt",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.createdAt, "dd/mm/yyyy HH:mm:ss ", true)),
            sort: ({ a, b, isAscending }) => {
                let aa = a.split("/").reverse().join(),
                    bb = b.split("/").reverse().join();
                return aa < bb
                    ? isAscending
                        ? -1
                        : 1
                    : aa > bb
                        ? isAscending
                            ? 1
                            : -1
                        : 0;
            }
        },
        {
            id: "buttons",
            label: "Action",
            width: '110px',
            pinned: true,
            sortable: false,
            resizable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (
                <div style={styles.styleButton.buttonsCellContainer}>
                    <button
                        title="View"
                        style={styles.styleButton.viewButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            modalDetail(data.code, "View");
                        }}
                    >
                        {styles.VIEW_SVG}
                    </button>
                </div>
            )
        }
    ];
};

export default setColumns;
